var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 3.75,
    height: 3.5625,
    id: "canvas_background",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 1.09375,
    y: 0.90332,
    width: 25.1875,
    height: 22.875,
    id: "svg_2",
    rx: 1,
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#23384f",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 2.96875,
    y: 2.46582,
    width: 21.125,
    height: 8.6875,
    id: "svg_5",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#23384f",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 6.71875,
    y: 12.90332,
    width: 13.5,
    height: 8.875,
    id: "svg_6",
    stroke: "null",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    stroke: "null",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 8.59375,
    y: 15.21582,
    width: 3.625,
    height: 4.5625,
    id: "svg_8"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    stroke: "null",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 15.84375,
    y: 12.46582,
    width: 1.4375,
    height: 10.25,
    id: "svg_10"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.b60827dda82025df22801dceee3ec693.svg";
export { ForwardRef as ReactComponent };